<script>

    export let icon = ''
    export let text = ''
    export let pointer = false

</script>

<style>

    .is-pointer{
        cursor: pointer;
    }

</style>

<span on:click class="icon-text" class:is-pointer={pointer}>
    <span class="icon">
        <i class="fas fa-{icon}"></i>
    </span>
    <span>{text}</span>
</span>